import React, { useState } from "react";
import "../../../components/layout/ModuleLayout.css";
import Toast, { ToastMessage } from "../../../components/common/Toast";

const IdentityPlaceholderBody: React.FC = () => {
  const [toast, setToast] = useState<ToastMessage | null>(null);

  return (
    <div className="netbody-card flex flex-col h-full">
      <div className="netbody-content">
        <div className="scroll-container-nofilters flex-1 overflow-hidden">
          <div className="flex items-center justify-center h-64 text-gray-400">
            Content coming soon...
          </div>
        </div>
      </div>

      <Toast toast={toast} onClose={() => setToast(null)} />
    </div>
  );
};

export default IdentityPlaceholderBody;
